// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"d8b490f9047587a58bba","966":"2529e484228c832e2edf"}[chunkId] + ".js";
};